
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import DefaultLayout from '@/components/DefaultLayout.vue';
import AdminService from '@/services/admin-service';
import ItemService from '@/services/item-service';
@Component({
  components: { DefaultLayout }
})
export default class ItemOrderExport extends Vue {
  $refs!: {
    defaultActions: HTMLFormElement;
  };
  /* Properties */
  /* Store Actions */
  /* Watchers */
  /* Data */
  customers: any[] = [];
  selectedCustomerId: string = '';
  isExporting: boolean = false;
  /* Computed */
  /* Functions */
  exportItems() {
    this.isExporting = true;
    if (this.selectedCustomerId) {
      const returnValue = ItemService.ExportItemsForOrder(this.selectedCustomerId).then(
        response => {
          const type = response.headers['content-type'];
          const blob = new Blob([response.data], {
            type: type
          });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'ordertemplate.csv';
          link.click();
        }
      );
    }
    this.isExporting = false;
  }
  /* Utility Functions */
  /* Loaders */
  /* Mounted */
  async mounted() {
    const customerResults = await AdminService.getAllCustomers(true);
    this.customers = [];
    customerResults.data.forEach((customer: any) => {
      this.customers.push({ ...customer, isVisible: true });
    });
  }
  /* Created */
  /* Emmited Functions */
}
